<template>
  <el-dialog
    :title="NewDependentFormTitle"
    :visible.sync="NewDependentFormIsVisible"
    width="20%"
    append-to-body
    @open="openingNewDependentForm"
    @close="onCloseNewDependentForm('NewDependentForm')"
  >
    <el-form
      :model="NewDependentForm"
      ref="NewDependentForm"
      :rules="NewDependentFormRules"
      status-icon
      size="medium"
      label-position="left"
    >
      <el-form-item label="Nombre del dependiente" prop="Name">
        <el-input
          v-model="NewDependentForm.Name"
          placeholder="Digite el Nombre"
        ></el-input>
      </el-form-item>
      <el-form-item label="Parentesco" prop="relationship">
        <el-select v-model="NewDependentForm.relationship" placeholder="Select">
          <el-option
            v-for="item in relationships"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Cédula" prop="Identification">
        <el-input
          v-model="NewDependentForm.Identification"
          placeholder="Digite la cédula"
        ></el-input>
      </el-form-item>
      <el-form-item label="Monto" prop="Amount">
        <el-input
          v-model="NewDependentForm.Amount"
          type="number"
          placeholder="Digite el Monto a cobrar"
        ></el-input>
      </el-form-item>
    </el-form>
    <el-form-item label="Descuento Fijo?" prop="FixedDiscount">
      <el-switch
        v-model="NewDependentForm.FixedDiscount"
        active-text="Si"
        inactive-text="No"
      >
      </el-switch>
    </el-form-item>
    <el-form-item
      label="Desde cuando?"
      prop="FromDate"
      v-if="NewDependentForm.FixedDiscount === false"
    >
      <el-date-picker
        v-model="NewDependentForm.FromDate"
        type="date"
        placeholder="Seleccione una fecha de Inicio"
      >
      </el-date-picker>
    </el-form-item>
    <el-form-item
      label="Hasta cuando?"
      prop="ToDate"
      v-if="NewDependentForm.FixedDiscount === false"
    >
      <el-date-picker
        v-model="NewDependentForm.ToDate"
        type="date"
        placeholder="Seleccione una fecha final"
      >
      </el-date-picker>
    </el-form-item>
    <el-row type="flex" justify="start">
      <el-form-item label="Quincena" prop="Biweekly">
        <el-radio-group v-model="NewDependentForm.Biweekly">
          <el-radio-button label="1">1ra</el-radio-button>
          <el-radio-button label="2">2da</el-radio-button>
          <el-radio-button label="0">Ambas</el-radio-button>
        </el-radio-group>
      </el-form-item>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="onCloseNewDependentForm('NewDependentForm')"
        >Cancelar</el-button
      >
      <el-button type="primary" @click="AddNewDependentForm('NewDependentForm')"
        >Confirmar</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AddNewDependent",
  props: {
    NewDependentFormView: {
      type: Boolean,
      default: false
    },
    EmployeeInfo: {
      type: Object,
      default: () => {}
    },
    ActualDependentInfo: {
      type: Object,
      default: () => {}
    },
    Command: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      NewDependentFormTitle: "Agregar Nuevo dependiente",
      NewDependentForm: {
        Name: "",
        Identification: "",
        relationship: "",
        Amount: "",
        FixedDiscount: true,
        FromDate: "",
        ToDate: "",
        Biweekly: "2"
      },
      NewDependentFormRules: {
        Name: [
          {
            required: true,
            message: "Este campo es requerido",
            trigger: "blur"
          }
        ],
        Identification: [
          {
            required: true,
            message: "Este campo es requerido",
            trigger: "blur"
          }
        ],
        relationship: [
          {
            required: true,
            message: "Este campo es requerido",
            trigger: "blur"
          }
        ],
        Amount: [
          {
            required: true,
            message: "Este campo es requerido",
            trigger: "blur"
          }
        ],
        FixedDiscount: [
          {
            required: true,
            message: "Este campo es requerido",
            trigger: "blur"
          }
        ],
        FromDate: [
          {
            required: true,
            message: "Este campo es requerido",
            trigger: "blur"
          }
        ],
        ToDate: [
          {
            required: true,
            message: "Este campo es requerido",
            trigger: "blur"
          }
        ],
        Biweekly: [
          {
            required: true,
            message: "Este campo es requerido",
            trigger: "blur"
          }
        ]
      },
      relationships: [
        {
          label: "Titular",
          value: "Titular"
        },
        {
          label: "Padre",
          value: "Padre"
        },
        {
          label: "Madre",
          value: "Madre"
        },
        {
          label: "Hermano",
          value: "Hermano"
        },
        {
          label: "Hermana",
          value: "Hermana"
        },
        {
          label: "Hijo",
          value: "Hijo"
        },
        {
          label: "Hija",
          value: "Hija"
        },
        {
          label: "Hijastro",
          value: "Hijastro"
        },
        {
          label: "Hijastra",
          value: "Hijastra"
        },
        {
          label: "Suegro",
          value: "Suegro"
        },
        {
          label: "suegra",
          value: "suegra"
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      getEmployee: "employees/getEmployee",
      getActualLefTab: "employees/getActualLefTab"
    }),
    NewDependentFormIsVisible() {
      return this.NewDependentFormView;
    },
    GetEmployeeInfo() {
      return this.EmployeeInfo;
    }
  },
  methods: {
    openingNewDependentForm() {
      if (this.Command === "edit_insurance") {
        this.NewDependentForm = this.ActualDependentInfo;
      }
    },
    onCloseNewDependentForm(formName) {
      this.$refs[formName].resetFields();
      this.ResetNewDependentForm();
      this.$emit("onCloseNewDependentForm");
    },
    async AddNewDependentForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let actualDate = new Date();
          let body = {};
          if (this.getActualLefTab === "PrivateInsurance") {
            body = {
              insuranceType: 1, //insuranceType 1 indica seguro privado / insuranceType 0 indica PERCAPITA
              EmployeeId: this.getEmployee.ID,
              Name: this.NewDependentForm.Name,
              relationship: this.NewDependentForm.relationship,
              Identification: this.NewDependentForm.Identification,
              Amount: this.NewDependentForm.Amount,
              FixedDiscount: this.NewDependentForm.FixedDiscount,
              Biweekly: this.NewDependentForm.Biweekly,
              CreatedAt: actualDate,
              FromDate: this.NewDependentForm.FromDate,
              ToDate: this.NewDependentForm.ToDate,
              IsDelete: false
            };
          } else if (this.getActualLefTab === "PERCAPITAL") {
            body = {
              insuranceType: 0, //insuranceType 1 indica seguro privado / insuranceType 0 indica PERCAPITA
              EmployeeId: this.getEmployee.ID,
              Name: this.NewDependentForm.Name,
              relationship: this.NewDependentForm.relationship,
              Identification: this.NewDependentForm.Identification,
              Amount: this.NewDependentForm.Amount,
              FixedDiscount: this.NewDependentForm.FixedDiscount,
              Biweekly: this.NewDependentForm.Biweekly,
              CreatedAt: actualDate,
              FromDate: this.NewDependentForm.FromDate,
              ToDate: this.NewDependentForm.ToDate,
              IsDelete: false
            };
          }

          if (this.Command === "edit_insurance") {
            body.Id = this.ActualDependentInfo.Id;

            this.$http
              .put("/api/CXC/EditDependent", body)
              .then(async () => {
                this.ResetNewDependentForm();
                await this.RecalculatePayroll();
                this.$emit("PrivateInsuranceAdded");
              })
              .catch((err) => {
                console.error(err);
              });
          } else {
            await this.$http
              .post("/api/CXC/AddNewPrivateInsuranceDependent", body)
              .then(async () => {
                this.ResetNewDependentForm();
                await this.RecalculatePayroll();
                this.$emit("PrivateInsuranceAdded");
              })
              .catch((err) => {
                console.error(err);
              });
          }
        } else {
          return false;
        }
      });
    },
    async RecalculatePayroll() {
      const body = {};
      await this.$http
        .put("/api/Payroll/RecalcularNominaDesdeFuera", body)
        .then(() => {})
        .catch((err) => {
          console.error(err);
        });
    },
    ResetNewDependentForm() {
      this.NewDependentForm = {
        Name: "",
        Identification: "",
        relationship: "",
        Amount: "",
        FixedDiscount: true,
        FromDate: "",
        ToDate: "",
        Biweekly: "2"
      };
    }
  }
};
</script>

<style></style>
